import { render } from "./ViewTerms.vue?vue&type=template&id=0bb38bc0"
import script from "./ViewTerms.vue?vue&type=script&lang=js"
export * from "./ViewTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__